import React from 'react';
import './Hero.scss';

const Hero = () => {
  return (
    <section className='hero'>
      <div className='container'>
        <div className='hero__wrapper'>
          <div className='hero__content'>
            <div className='hero__text'>
              <h1>Professionelle Reinigung für jede Umgebung</h1>
              <p>
                Ob Zuhause, Büro oder Gewerbe – wir schaffen Sauberkeit, die
                Räume verwandelt und für Wohlbefinden sorgt.
              </p>
              <a
                href='#contact'
                className='hero__button'>
                Anfrage senden
              </a>
            </div>

            <div className='hero__image'>
              <img
                src='./img/team-img.jpg'
                alt='Professionelle Reinigungsdienstleistungen'
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
